import styled from 'styled-components'

export const Section = styled.section`
  margin-top: 111px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 24px;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 900px) {
    margin-top: 64px;
    padding: 0 24px;
  }
`

export const Title = styled.h2`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 28px;
  line-height: 100%;
  text-align: center;
  color: #21105d;
  margin-bottom: 32px;

  @media (max-width: 900px) {
    font-size: 24px;
  }
`

export const CarouselWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  max-width: var(--unsignedMaxWidth);
`

export const StyledSwiper = styled.div`
  width: 100%;
  margin-bottom: 32px;

  .swiper {
    width: 100%;
    padding: 10px 0;
    overflow: visible;
  }

  .swiper-slide {
    display: flex;
    justify-content: center;
    height: auto;
  }
`

export const Card = styled.div`
  width: 100%;
  max-width: 402px;
  height: 282px;
  border-radius: 50px;
  background: #f8f9fd;
  padding: 32px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;

  @media (max-width: 900px) {
    height: 190px;
    min-height: unset;
    padding: 24px;
    justify-content: flex-start;
    border-radius: 30px;
  }
`

export const Text1 = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: #212429;
  margin-bottom: 32px;

  @media (max-width: 900px) {
    font-size: 10px !important;
    line-height: 14px;
    margin-bottom: 21px;
  }
`

export const Text2 = styled.div`
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  line-height: 24px;
  color: #212429;

  strong {
    font-weight: 600;
  }

  br + strong {
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
  }

  @media (max-width: 900px) {
    font-size: 10px !important;
    line-height: 14px;

    br + strong {
      font-size: 10px !important;
      line-height: 14px;
    }
  }
`

export const Bullets = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
`

export const Bullet = styled.button<{ active?: boolean }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 1px solid #21105d;
  background: ${({ active }) => (active ? '#21105D' : 'transparent')};
  cursor: pointer;
  transition:
    background 0.2s,
    border-color 0.2s;
  padding: 0;
  box-sizing: border-box;

  &:hover {
    background: #21105d;
  }
`
